export const errorMsg = ({ errorMsg }) => errorMsg;
export const successMsg = ({ successMsg }) => successMsg;
export const isLoading = ({ isLoading }) => isLoading;
export const highlightAddress = ({ highlightAddress }) => highlightAddress;
export const highlightMethod = ({ highlightMethod }) => highlightMethod;
export const highlightTx = ({ highlightTx }) => highlightTx;
export const displayDecimals = ({ displayDecimals }) => displayDecimals;

